module.exports = __webpack_public_path__ + "img/international-locations.b58de723.png";